export default __webpack_public_path__ + "static/9008-lense-box2-d3d1db6e703d2d95563fe2e91afe5928.webp";